<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Microsoft YaHei UI", "PingFang SC", "Noto Sans SC", "Source Han Sans SC",
    -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background: #030814;
  color: #f4f8ff;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
  font-synthesis: none;
  text-rendering: optimizeLegibility;
}

a {
  text-decoration: none;
  color: inherit;
}

button,
input,
textarea {
  font-family: inherit;
}

.el-loading-mask {
  background-color: rgba(3, 8, 20, 0.74) !important;
  backdrop-filter: blur(10px);
}

.el-empty__description p {
  color: #aebbd0 !important;
}

@media screen and (max-width: 768px) {
  .el-message-box {
    width: 90% !important;
  }
  .el-dialog {
    width: 95% !important;
    margin-top: 10vh !important;
  }
}
</style>
